import { render } from "./NcrmPrivacyPurposesSection.vue?vue&type=template&id=5dc5dd8a&scoped=true"
import script from "./NcrmPrivacyPurposesSection.vue?vue&type=script&lang=js"
export * from "./NcrmPrivacyPurposesSection.vue?vue&type=script&lang=js"

import "./NcrmPrivacyPurposesSection.vue?vue&type=style&index=0&id=5dc5dd8a&scoped=true&lang=css"

import exportComponent from "../../../../node_modules/@vue/cli-service/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5dc5dd8a"]])

export default __exports__